/**
 * URL parameters are copied into sessionStorage so the app can use them after the URL has been cleaned up.
 * Because several of these values end up in HTML, never trust them: refuse keys that would overwrite cached
 * application state and validate the values we know the format of.
 */
const valuePatterns: { [key: string]: RegExp } = {
	language: /^[A-Za-z]{2}$/,
	languageId: /^\d+$/,
	evaPortal: /^[a-zA-Z0-9-]+$/,
	invitationToken: /^[\w-]+$/
};

export function storeUrlParam(key: string, value: string): void {
	// Never let a URL overwrite cached application state (it is rendered as HTML later on).
	if (/^current[A-Z]/.test(key)) {
		return;
	}
	const pattern = valuePatterns[key];
	if (pattern && !pattern.test(value)) {
		return;
	}
	sessionStorage.setItem(key, value);
}
